// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".parentbg {\n  width: 100%;\n  height: 600px;\n  background-color: #ffffff;\n  padding: 20px;\n  padding-top: 0px;\n  overflow-y: scroll;\n}\n", ""]);
// Exports
module.exports = exports;
